import { MapPin } from "lucide-react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

export const PROVINCES = [
  "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador",
  "Northwest Territories", "Nova Scotia", "Nunavut", "Ontario", "Prince Edward Island",
  "Quebec", "Saskatchewan", "Yukon",
];

export const EMPTY_ADDRESS = { name: "", line1: "", line2: "", city: "", province: "", postal_code: "", country: "Canada", phone: "" };

export const validateShippingAddress = (a) => {
  if (!a.name.trim()) return "Please enter the recipient's full name.";
  if (!a.line1.trim()) return "Please enter your street address.";
  if (!a.city.trim()) return "Please enter your city.";
  if (!a.province) return "Please select your province.";
  if (!/^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/.test(a.postal_code.trim())) return "Please enter a valid Canadian postal code (e.g. K1A 0B1).";
  return null;
};

export const ShippingAddressForm = ({ address, onChange }) => {
  const set = (key) => (e) => onChange({ ...address, [key]: e.target.value });
  return (
    <div className="border border-[#DDD7CF] rounded-lg p-8 bg-white mb-8" data-testid="shipping-address-form">
      <div className="flex items-center gap-3 mb-6">
        <MapPin className="w-6 h-6 text-[#8C7B6B]" />
        <h2 className="font-display text-lg sm:text-xl uppercase tracking-wide text-[#1A1A1A]">Shipping Address</h2>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <div className="sm:col-span-2">
          <Label htmlFor="addr-name">Full Name *</Label>
          <Input id="addr-name" data-testid="address-name-input" value={address.name} onChange={set("name")} autoComplete="name" className="mt-1" />
        </div>
        <div className="sm:col-span-2">
          <Label htmlFor="addr-line1">Street Address *</Label>
          <Input id="addr-line1" data-testid="address-line1-input" value={address.line1} onChange={set("line1")} autoComplete="address-line1" placeholder="123 Main St" className="mt-1" />
        </div>
        <div className="sm:col-span-2">
          <Label htmlFor="addr-line2">Unit / Suite # (optional)</Label>
          <Input id="addr-line2" data-testid="address-line2-input" value={address.line2} onChange={set("line2")} autoComplete="address-line2" placeholder="106" className="mt-1" />
        </div>
        <div>
          <Label htmlFor="addr-city">City *</Label>
          <Input id="addr-city" data-testid="address-city-input" value={address.city} onChange={set("city")} autoComplete="address-level2" className="mt-1" />
        </div>
        <div>
          <Label htmlFor="addr-province">Province *</Label>
          <select
            id="addr-province"
            data-testid="address-province-select"
            value={address.province}
            onChange={set("province")}
            autoComplete="address-level1"
            className="mt-1 flex h-11 md:h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base md:text-sm shadow-sm focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
          >
            <option value="">Select province…</option>
            {PROVINCES.map((p) => (
              <option key={p} value={p}>{p}</option>
            ))}
          </select>
        </div>
        <div>
          <Label htmlFor="addr-postal">Postal Code *</Label>
          <Input id="addr-postal" data-testid="address-postal-input" value={address.postal_code} onChange={set("postal_code")} autoComplete="postal-code" autoCapitalize="characters" placeholder="K1A 0B1" className="mt-1" />
        </div>
        <div>
          <Label htmlFor="addr-phone">Phone (optional)</Label>
          <Input id="addr-phone" data-testid="address-phone-input" type="tel" inputMode="tel" value={address.phone} onChange={set("phone")} autoComplete="tel" className="mt-1" />
        </div>
      </div>
      <p className="text-xs text-[#6E675F] mt-5">Shipping within Canada only.</p>
    </div>
  );
};
